import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import './styles/themes.css';
import './styles/buttons.css';
import './styles/responsive.css';
import './styles/security.css';
import './utils/themeInit';
import App from './App';

const root = ReactDOM.createRoot(
  document.getElementById('root')
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);